import React, { useState, useEffect } from "react";
import {
  MetalsList,
  ColorsList,
  SizesList,
  StonesList,
  ShapesList,
  CutsList,
  ClaritysList,
  StonecolorsList,
  CertificateTypeList,
  GetPointers,
  StonesizeList,
  StonesettingType,
} from "../../common/graphql/productmastermodal";
import { numberFormatter } from "Helper/PriceHelper";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MultiSelect from "react-select";
const ProductModal = (props) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const {
    data_product,
    setOneproduct,
    editproduct_submit,
    country,
    canEditProductInfo,
  } = props;
  const [showbutton, setShowbutton] = useState(false);
  const [activeStoneWeightKey, setActiveStoneWeightKey] = useState(null);
  const [coloridbymetal, setcoloridbymetal] = useState();
  const [grosswt, setGrosswt] = useState();
  const [netwt, setNetWt] = useState();
  const location = useLocation();
  const reportlocation = location.pathname.split("report")[1];

  const toWeightNumber = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const getStoneWeightDisplayValue = (stone, key) => {
    if (stone?.Cts === "" || stone?.Cts == null) return "";
    if (activeStoneWeightKey === key) return String(stone.Cts ?? "");
    const formatted = numberFormatter(toWeightNumber(stone.Cts));
    return formatted === "NaN" ? "" : formatted;
  };

  const updateData_productContent = (index, key, value) => {
    if (data_product["Stones"] && data_product["Stones"][index]) {
      const stone = { ...data_product.Stones[index] };
      if (key === "certificate") {
        stone.certificate = { ...stone.certificate, type: value };
      } else if (key === "certificatenumber") {
        stone.certificate = { ...stone.certificate, number: value };
      } else {
        stone[key] = value;
      }

      setOneproduct((prevProduct) => ({
        ...prevProduct,
        Stones: [
          ...prevProduct.Stones.slice(0, index),
          stone,
          ...prevProduct.Stones.slice(index + 1),
        ],
      }));
    }
  };
  const updateData_productContentformultiplekeys = (index, updates) => {
  if (!data_product["Stones"] || !data_product["Stones"][index]) return;

  const stone = { ...data_product.Stones[index] };

  // Apply all updates
  Object.entries(updates).forEach(([key, value]) => {
    if (key === "certificate") {
      // If value is object → merge deeply
      stone.certificate = { ...stone.certificate, ...value };
    } else if (key.startsWith("certificate.")) {
      // Handle certificate sub-fields like "certificate.type"
      const subKey = key.split(".")[1];
      stone.certificate = { ...stone.certificate, [subKey]: value };
    } else {
      stone[key] = value;
    }
  });

  // Update state immutably
  setOneproduct((prevProduct) => ({
    ...prevProduct,
    Stones: [
      ...prevProduct.Stones.slice(0, index),
      stone,
      ...prevProduct.Stones.slice(index + 1),
    ],
  }));
};

  const handleProductDesignChange = (field, value) => {
    setOneproduct((prev) => ({
      ...prev,
      product_design_trace_detail: {
        ...prev.product_design_trace_detail,
        [field]: value,
      },
    }));
  };
  const handleOriginChange = (key, selected) => {
    setOneproduct((prev) => {
      const newTraceability = { ...prev.traceability };
      newTraceability[key] = {
        ...newTraceability[key],
        countries: selected.map((s) => ({ value: s.value, label: s.label })),
      };
      return { ...prev, traceability: newTraceability };
    });
  };

  const handleTransactionIdChange = (key, e) => {
    const value = e.target.value;
    setOneproduct((prev) => {
      const newTraceability = { ...prev.traceability };
      newTraceability[key] = {
        ...newTraceability[key],
        transactionId: value,
      };
      return { ...prev, traceability: newTraceability };
    });
  };

const handleDateTimeChange = (key, e) => {
  // Keep only digits
  let digits = e.target.value.replace(/\D/g, "");

  // Limit to max 10 digits: ddmmyyhhmm (2-digit year)
  if (digits.length > 10) {
    digits = digits.slice(0, 10);
  }

  // Format progressively
  let formatted = "";

  if (digits.length > 0) {
    formatted += digits.slice(0, 2); // dd
  }
  if (digits.length >= 3) {
    formatted += "/" + digits.slice(2, 4); // mm
  }
  if (digits.length >= 5) {
    formatted += "/" + digits.slice(4, 6); // yy (2-digit year)
  }
  if (digits.length > 6) {
    formatted += " " + digits.slice(6, 8); // hh
  }
  if (digits.length > 8) {
    formatted += ":" + digits.slice(8, 10); // mm
  }

  // Update state with explicit return
  setOneproduct((prev) => {
    const newTraceability = { ...prev.traceability };
    newTraceability[key] = {
      ...newTraceability[key],
      dateTime: formatted,
    };
    return { ...prev, traceability: newTraceability };
  });
};


  const updateData_productbymain = (id, value, name, lable) => {
    setOneproduct((prev) => {
      if (!prev) {
        return prev;
      }
      const dataupdate = { ...prev, [id]: value };
      if (name) {
        dataupdate[name] = lable;
      }
      return dataupdate;
    });
  };

  const handleMetalChange = (metalId, metalName, linkedColorId) => {
    setcoloridbymetal(linkedColorId);
    setOneproduct((prev) => {
      if (!prev) {
        return prev;
      }
      return {
        ...prev,
        Metal: metalId,
        metal_name: metalName,
        ...(linkedColorId ? { Color: linkedColorId } : {}),
      };
    });
  };
  const updateData_priceContent = (index, key, value) => {
    let dataupdate = { ...data_product };
    dataupdate["PriceDetails"][index][key] = Number(value);
    setOneproduct(dataupdate);
  };

  const addmore = () => {
    let dataupdate = { ...data_product };
    const array = {
      stone_group: "",
      stone: "",
      Variant: 0,
      Align: "",
      shape: "",
      Cut: "",
      quality: "",
      clarity: "",
      color: "",
      Size: "",
      Unit: "cts",
      Pcs: "",
      Cts: "",
      Price: "",
      Pointer: "",
      setting_type: "",
      certificate: {
        type: "",
        number: "",
      },
    };
    // New array: push on the shared one also changed the table row before Save.
    dataupdate["Stones"] = [...(dataupdate["Stones"] || []), array];
    setOneproduct(dataupdate);
  };
  const removestone = (key) => {
    let dataupdate = { ...data_product };
    dataupdate["Stones"] = (dataupdate["Stones"] || []).filter((_, index) => index !== key);
    setOneproduct(dataupdate);
  };
  useEffect(() => {
    if (data_product) {
      setGrosswt(numberFormatter(data_product?.GrossWt));
      setNetWt(numberFormatter(data_product?.NetWt));
    }
  }, [data_product]);

  useEffect(() => {
    setActiveStoneWeightKey(null);
  }, [
    data_product?.po_product_id,
    data_product?.product_id,
    data_product?._id,
  ]);

  useEffect(() => {
    if (!showbutton) {
      setActiveStoneWeightKey(null);
    }
  }, [showbutton]);

  const isMyInventoryRoute =
    location.pathname === "/app/inventory/myInventory";
  const isReworkOrderRoute =
    location.pathname === "/app/inventory/createPOReworkOrder";
  const shouldFilterPriceByLocation =
    isMyInventoryRoute || isReworkOrderRoute;

  const productPriceDetails = shouldFilterPriceByLocation
    ? data_product?.PriceDetails?.filter(
        (item) => item.location === data_product?.location_id
      )
    : data_product?.PriceDetails;
  const isProductTypeProduct = data_product?.product_type === "product";
  const isProductTypeVariant = data_product?.product_type === "variant";
  const isVariantAttributeLocked =
    isProductTypeVariant &&
    (data_product?.is_variant === 1 || data_product?.is_design === 1);
  const isStoneSpecFieldLocked = isProductTypeVariant;
  // product_type "product": full stone management everywhere (same as My Inventory).
  // product_type "variant": attribute/spec locks above apply on every route.
  const canManageStones = isProductTypeProduct;
  const canShowProductEditActions =
    !isMyInventoryRoute || canEditProductInfo;
  const useSidebarEditMode =
    showbutton &&
    (location.pathname === "/app/inventory/purchaseOrdersOutstanding" ||
      location.pathname === "/app/inventory/editPurchase" ||
      isProductTypeVariant);

  return (
    <>
      <div
        className="modal fade product-modal product-sidebar-area"
        id="ProductInfoModal"
        tabIndex="-1"
        aria-labelledby="ProductInfoModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className={
            showbutton
              ? useSidebarEditMode
                ? "modal-dialog not-edit-sidebar"
                : "modal-dialog"
              : "modal-dialog not-edit"
          }
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="ProductInfoModalLabel">
                {t("Product")}
              </h5>
              <button
                type="button"
                className="btn-close shadow-none"
                onClick={() => setShowbutton(false)}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body ">
              <div className="product-modal-header-wrap">
                <div className="product-modal-header">
                  <h1 className="product-modal-header-heading">
                    {t("Information")}
                  </h1>
                  {location.pathname === "/app/inventory" ||
                  location.pathname === "/app/inventory/transactionPurchase" ||
                  location.pathname === "/app/inventory" ||
                  location.pathname === "/app/inventory/stock_transfer" ||
                  location.pathname ===
                    "/app/inventory/transactionStockReceive" ||
                  location.pathname === "/app/inventory/createreserves" ||
                  reportlocation !== undefined ||
                  location.pathname === "/app/inventory/summary" ||
                  location.pathname === "/app/inventory/skumovement" ||
                  location.pathname === "/app/inventory/stockidmovement" ||
                  (isMyInventoryRoute && !canShowProductEditActions) ? (
                    ""
                  ) : (
                    <>
                      <button
                        className={
                          !showbutton
                            ? "product-modal-header-btn btn-style border-none"
                            : "d-none"
                        }
                      >
                        <img
                          className="product-modal-header-btn-img"
                          onClick={() => setShowbutton(true)}
                          src={base_assets + "images/icons/edit-pencil.png"}
                          alt=""
                        />
                      </button>
                      <button
                        className={
                          showbutton
                            ? "product-modal-header-btn btn-style border-none"
                            : "d-none"
                        }
                      >
                        <img
                          className="product-modal-header-btn-img"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setShowbutton(false);
                            editproduct_submit();
                          }}
                          src={base_assets + "images/icons/save-icon.png"}
                          alt=""
                        />
                      </button>
                    </>
                  )}
                </div>
                <div className="product-modal-row product-modal-row-detail">
                  <div className=" product-modal-row-detail-inner">
                    <div className="product-modal-row-detail-inner-left">
                      <img src={data_product?.main_image} alt="" />
                    </div>
                    <div className="product-modal-row-detail-inner-right">
                      <h3 className="product-modal-row-detail-inner-right-pro-heading">
                        #{data_product?.name ? data_product?.name : "-"}
                      </h3>
                      <div className="product-modal-row-detail-inner-right-cols">
                        <div className="product-modal-row-detail-inner-right-cols-single">
                          <label className="product-modal-row-detail-inner-right-cols-single-label">
                            {t("Product ID")}
                          </label>
                          <span className="product-modal-row-detail-inner-right-cols-single-text">
                            {data_product?.ID ? data_product?.ID : "-"}
                          </span>
                        </div>
                        <div className="product-modal-row-detail-inner-right-cols-single">
                          <label className="product-modal-row-detail-inner-right-cols-single-label">
                            {t("SKU")}
                          </label>
                          <span className="product-modal-row-detail-inner-right-cols-single-text">
                            {data_product?.SKU ? data_product?.SKU : "-"}
                          </span>
                        </div>
                        {isMyInventoryRoute && data_product?.stock_id ? (
                          <div className="product-modal-row-detail-inner-right-cols-single">
                            <label className="product-modal-row-detail-inner-right-cols-single-label">
                              {t("Stock ID")}
                            </label>
                            <span className="product-modal-row-detail-inner-right-cols-single-text">
                              {data_product.stock_id}
                            </span>
                          </div>
                        ) : null}
                        <div className="product-modal-row-detail-inner-right-cols-single">
                          {data_product?.is_variant === 1 ? (
                            <img
                              className=""
                              src={base_assets + "images/icons/variant-sm.png"}
                              alt=""
                            />
                          ) : null}
                          {data_product?.is_design === 1 ? (
                            <img
                              className=""
                              src={base_assets + "images/pro-ring-img.png"}
                              alt=""
                            />
                          ) : null}
                        </div>
                      </div>
                      {data_product?.Matatag ? (
                        <div className="mt-2">
                          <label className="product-modal-row-detail-inner-right-cols-single-label">
                            {t("Meta Tag")}
                          </label>
                          <p className="product-modal-row-detail-inner-right-pro-para mb-0">
                            {data_product.Matatag}
                          </p>
                        </div>
                      ) : null}
                      {data_product?.Description ? (
                        <div className="mt-2">
                          <label className="product-modal-row-detail-inner-right-cols-single-label">
                            {t("Description")}
                          </label>
                          {/* Max 3 lines, then "..."; hover shows the full text */}
                          <p
                            className="product-modal-row-detail-inner-right-pro-para mb-0"
                            title={data_product.Description}
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {data_product.Description}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {location.pathname === "/app/inventory/myInventory" ? (
                    <div className="product-modal-row-detail-right">
                      <div className="product-sidebar-box box-bg">
                        <div className="product-sidebar-box-form">
                          <textarea
                            readOnly={!showbutton}
                            className="product-sidebar-box-form-textarea p-0"
                            onChange={(e) =>
                              updateData_productbymain(
                                "extra_po_information",
                                e.target.value,
                                "",
                                ""
                              )
                            }
                            value={
                              data_product?.extra_po_information
                                ? data_product?.extra_po_information
                                : ""
                            }
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="product-modal-scroll">
                <div className="product-modal-row">
                  <div className="product-modal-row-col-left">
                    <div className="product-modal-row-col-left-row">
                      <MetalsList
                        updateData_productbymain={updateData_productbymain}
                        onMetalChange={handleMetalChange}
                        setcoloridbymetal={setcoloridbymetal}
                        metalid={data_product?.Metal ? data_product?.Metal : ""}
                        addclass={isVariantAttributeLocked}
                      />
                      <ColorsList
                        updateData_productbymain={updateData_productbymain}
                        colorid={
                          data_product?.Color || coloridbymetal
                        }
                        addclass={isVariantAttributeLocked}
                      />
                      <SizesList
                        updateData_productbymain={updateData_productbymain}
                        product_id={data_product?.product_id}
                        sizeid={data_product?.Size ? data_product?.Size : ""}
                        addclass={isVariantAttributeLocked}
                      />
                    </div>
                  </div>
                  <div className="product-modal-row-col-right">
                    <div className="product-sidebar-box box-bg box-input-40">
                      <div className="product-sidebar-box-form">
                        <table>
                          <tbody>
                            <>
                              <tr>
                                <td>
                                  <label>{t("Gross Wt")}</label>
                                </td>
                                <td>
                                  <div className="placeholder-up-input w-100">
                                    <input
                                      className="box-input"
                                      value={grosswt}
                                      onChange={(e) =>
                                        setGrosswt(e.target.value)
                                      } // type normally
                                      onBlur={(e) => {
                                        const formatted = numberFormatter(
                                          e.target.value
                                        );
                                        setGrosswt(formatted);
                                        updateData_productbymain(
                                          "GrossWt",
                                          toWeightNumber(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <label>{t("Net Wt")}</label>
                                </td>
                                <td>
                                  <div className="placeholder-up-input w-100">
                                    <input
                                      className="box-input"
                                      value={netwt}
                                      onChange={(e) => {
                                        // 1) keep whatever you type, unformatted
                                        setNetWt(e.target.value);
                                      }}
                                      onBlur={(e) => {
                                        const formatted = numberFormatter(
                                          e.target.value
                                        );
                                        setNetWt(formatted);
                                        updateData_productbymain(
                                          "NetWt",
                                          toWeightNumber(e.target.value)
                                        );
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            </>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {data_product?.Stones?.length
                  ? data_product?.Stones.map((result, key) => {
                      return (
                        <div className="product-modal-row" key={key}>
                          <div className="product-modal-row-col-left">
                            {data_product?.Stones?.length > 1 ? (
                              <div className="product-modal-row-col-left-serial">
                                {t("Stone")} #{key + 1}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="product-modal-row-col-left-row">
                              <StonesList
                                updateData_productContent={
                                  updateData_productContent
                                }
                                updateData_productContentformultiplekeys={
                                  updateData_productContentformultiplekeys
                                }
                                index={key}
                                stoneid={result?.stone}
                                groupid={result?.stone_group}
                                addclass={isVariantAttributeLocked}
                                yellow_color={
                                  result?.Variant === "2" ? true : false
                                }
                              />
                              <ShapesList
                                updateData_productContent={
                                  updateData_productContent
                                }
                                index={key}
                                shapeid={result?.shape}
                                addclass={isStoneSpecFieldLocked}
                                light_yellow_color={
                                  (data_product?.product_type === "product" ||
                                    data_product?.product_type === "variant") &&
                                  data_product?.is_design === 1 &&
                                  result?.Variant === "2"
                                    ? true
                                    : false
                                }
                              />
                              <CutsList
                                updateData_productContent={
                                  updateData_productContent
                                }
                                cutid={result?.Cut}
                                index={key}
                                addclass={isStoneSpecFieldLocked}
                                light_yellow_color={
                                  (data_product?.product_type === "product" ||
                                    data_product?.product_type === "variant") &&
                                  data_product?.is_design === 1 &&
                                  result?.Variant === "2"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                            <div className="product-modal-row-col-left-row">
                              <div className="yelllow-effect-light col">
                                <ClaritysList
                                  updateData_productContent={
                                    updateData_productContent
                                  }
                                  clarityid={result?.clarity}
                                  index={key}
                                  addclass={isStoneSpecFieldLocked}
                                  light_yellow_color={
                                    (data_product?.product_type === "product" ||
                                      data_product?.product_type ===
                                        "variant") &&
                                    data_product?.is_design === 1 &&
                                    result?.Variant === "2"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              <div className="yelllow-effect-light col">
                                <StonecolorsList
                                  updateData_productContent={
                                    updateData_productContent
                                  }
                                  stonecolorid={result?.color}
                                  index={key}
                                  addclass={isStoneSpecFieldLocked}
                                  light_yellow_color={
                                    (data_product?.product_type === "product" ||
                                      data_product?.product_type ===
                                        "variant") &&
                                    data_product?.is_design === 1 &&
                                    result?.Variant === "2"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </div>
                            <div className="product-modal-row-col-left-row certificate-row">
                              <CertificateTypeList
                                updateData_productContent={
                                  updateData_productContent
                                }
                                certificatelistid={result?.certificate?.type}
                                index={key}
                              />
                              <div className="product-modal-row-col-left-row-input fg-4">
                                <div className="placeholder-up-input  w-100">
                                  <input
                                    type="text"
                                    className="placeholder-up-input-field form-control bg-white"
                                    value={result?.certificate?.number}
                                    onChange={(e) => {
                                      updateData_productContent(
                                        key,
                                        "certificatenumber",
                                        e.target.value
                                      );
                                    }}
                                    placeholder=""
                                  />
                                  <label className="placeholder-up-input-label">
                                    {t("Certificate No.")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="product-modal-row-col-right">
                            <div className="product-sidebar-box box-bg box-input-40">
                              <div className="product-sidebar-box-form">
                                <table>
                                  <tbody>
                                    <>
                                      {result?.Variant === "2" ? (
                                        <tr>
                                          <td>
                                            <label>{t("Pointer")}</label>
                                          </td>
                                          <td>
                                            <GetPointers
                                              updateData_productContent={
                                                updateData_productContent
                                              }
                                              shape_id={result?.shape}
                                              index={key}
                                              pointerid={result?.Pointer}
                                            />
                                          </td>
                                        </tr>
                                      ) : (
                                        ""
                                      )}
                                      <tr>
                                        <td>
                                          <label>{t("Size")}</label>
                                        </td>
                                        <td>
                                          <StonesizeList
                                            updateData_productContent={
                                              updateData_productContent
                                            }
                                            shape_id={result?.shape}
                                            stonesizeid={result?.Size}
                                            index={key}
                                            updateData_productContentformultiplekeys={
                                              updateData_productContentformultiplekeys
                                            }
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <label>{t("Pcs")}</label>
                                        </td>
                                        <td>
                                          <div className="placeholder-up-input w-100">
                                            <input
                                              className="box-input"
                                              value={result?.Pcs}
                                              onChange={(e) => {
                                                updateData_productContent(
                                                  key,
                                                  "Pcs",
                                                  e.target.value
                                                );
                                              }}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <label>{t("Weight")}</label>
                                        </td>
                                        <td>
                                          <div className="placeholder-up-input w-100">
                                            <input
                                              className="box-input"
                                              readOnly={!showbutton}
                                              disabled={!showbutton}
                                              value={getStoneWeightDisplayValue(result, key)}
                                              onFocus={() => setActiveStoneWeightKey(key)}
                                              onChange={(e) => {
                                                updateData_productContent(
                                                  key,
                                                  "Cts",
                                                  e.target.value
                                                );
                                              }}
                                              onBlur={(e) => {
                                                const raw = e.target.value?.trim();
                                                updateData_productContent(
                                                  key,
                                                  "Cts",
                                                  raw === ""
                                                    ? ""
                                                    : numberFormatter(toWeightNumber(raw))
                                                );
                                                setActiveStoneWeightKey(null);
                                              }}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <label>{t("Setting")}</label>
                                        </td>
                                        <td>
                                          <StonesettingType
                                            updateData_productContent={
                                              updateData_productContent
                                            }
                                            updateData_productContentformultiplekeys={
                                              updateData_productContentformultiplekeys
                                            }
                                            settingid={result?.setting_type}
                                            index={key}
                                          />
                                        </td>
                                      </tr>
                                    </>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            {key !== 0 ? (
                              canManageStones ? (
                                <button
                                  type="button"
                                  onClick={() => {
                                    removestone(key);
                                  }}
                                  className="add-more-pro h-auto mt-3 danger-text "
                                >
                                  <img
                                    src={
                                      base_assets +
                                      "images/icons/minus-detail.png"
                                    }
                                    alt=""
                                  />
                                  {t("Remove")}
                                </button>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      );
                    })
                  : ""}
                {canManageStones ? (
                  <button
                    onClick={() => {
                      addmore();
                    }}
                    type="button"
                    className="add-more-pro m-auto my-2 "
                  >
                    <img
                      src={base_assets + "images/icons/add-detail.png"}
                      alt=""
                    />
                    {t("Add more stones")}
                  </button>
                ) : (
                  ""
                )}
                {location.pathname ===
                  "/app/inventory/purchaseOrdersOutstanding" ||
                location.pathname === "/app/inventory/editPurchase" ||
                location.pathname === "/app/inventory/transactionPurchase" ||
                location.pathname === "/app/inventory/myInventory" ||
                isReworkOrderRoute ? (
                  <div className="product-modal-row product-modal-currency-price">
                    <div className="product-modal-row-col-left">
                      <table className="product-modal-currency-price-table">
                        <thead>
                          <tr>
                            <th>{t("Currency")}</th>
                            <th>{t("Code")}</th>
                            <th>{t("Retail price")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {productPriceDetails?.length
                              ? productPriceDetails.map((result, key) => {
                                  const priceDetailIndex = shouldFilterPriceByLocation
                                      ? data_product?.PriceDetails?.indexOf(
                                          result
                                        )
                                      : key;
                                  return (
                                    <tr key={key}>
                                      <td>
                                        <div className="product-modal-currency-price-table-row">
                                          <span className="product-modal-currency-price-table-row-icon">
                                            <img
                                              src={
                                                base_assets +
                                                "images/flags/" +
                                                result?.currency?.toLowerCase() +
                                                ".png"
                                              }
                                              alt=""
                                            />
                                          </span>
                                          {result?.currency
                                            ? result?.currency
                                            : ""}
                                        </div>
                                      </td>
                                      <td>
                                        {result?.code
                                          ? result?.code
                                          : "No Code"}
                                      </td>
                                      <td>
                                        <div className="placeholder-up-input">
                                          <input
                                            className="product-modal-currency-price-table-row-input placeholder-up-input-field"
                                            value={
                                              result?.retailprice_Inc
                                                ? result?.retailprice_Inc
                                                : 0
                                            }
                                            disabled={!showbutton}
                                            onChange={(e) => {
                                              updateData_priceContent(
                                                priceDetailIndex,
                                                "retailprice_Inc",
                                                e.target.value
                                              );
                                            }}
                                            type="text"
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              : ""}
                          </>
                        </tbody>
                      </table>
                    </div>
                    <div className="product-modal-row-col-right">
                      <div className="product-sidebar-box box-bg box-input-40">
                        <div className="product-sidebar-box-form">
                          <textarea
                            className="product-sidebar-box-form-textarea"
                            readOnly={!showbutton}
                            onChange={(e) =>
                              updateData_productbymain(
                                "extra_po_information",
                                e.target.value,
                                "",
                                ""
                              )
                            }
                            value={
                              data_product?.extra_po_information
                                ? data_product?.extra_po_information
                                : ""
                            }
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {location.pathname === "/app/inventory/editPurchase"||location.pathname==="/app/inventory/purchaseOrdersOutstanding" ? (
                  <div className="product-modal-row product-modal-currency-price">
                    <div className="product-modal-row-col-left">
                      <table className="product-modal-currency-price1-table">
                        <thead>
                          <tr>
                            <th className="trace-th">{t("Traceability")}</th>
                            <th className="origin-th">{t("Origin")}</th>
                            <th>{t("Transaction ID")}</th>
                            <th>{t("Date Time")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* First row: Product Design */}
                          {data_product?.product_design_trace && (
                            <tr key="product_design">
                              <td className="multiselec-div-btn-heading">Product Design</td>

                              <td className="multiselec-div-btn-heading">
                                {data_product?.product_design_trace.label ||
                                  "-"}
                              </td>

                              <td>
                                 <div className="placeholder-up-input1">
                                <input
                                  type="text"
                                  value={
                                    data_product?.product_design_trace_detail
                                      ?.transactionId || ""
                                  }
                                  title={data_product?.product_design_trace_detail
                                      ?.transactionId || ""}
                                  id="product_design_trace_detail_transactionId"
                                  onChange={(e) =>
                                    handleProductDesignChange(
                                      "transactionId",
                                      e.target.value
                                    )
                                  }
                                  disabled={!showbutton} 
                                  className="product-modal-currency-price1-table-row-input placeholder-up-input-field multiselec-div-btn-heading truncate-input"
                                />
                                </div>
                              </td>

                              <td>
                                 {/* <div className="placeholder-up-input1">
                                <input
                                  type="text"
                                  value={
                                    data_product?.product_design_trace_detail
                                      ?.dateTime || ""
                                  }
                                  onChange={(e) =>
                                    handleProductDesignChange(
                                      "dateTime",
                                      e.target.value
                                    )
                                  }
                                  id="product_design_trace_detail_dateTime"
                                  placeholder={showbutton?"dd/mm/yy  hh:mm":""}
                                  className="product-modal-currency-price1-table-row-input placeholder-up-input-field"
                                />
                                </div> */}
                              </td>
                            </tr>
                          )}

                          {/* Other rows: traceability */}
                          {data_product?.traceability &&
                            Object.entries(data_product.traceability).map(
                              ([key, trace]) => {
                                return (
                                  <tr key={key}>
                                    <td className="multiselec-div-btn-heading">{trace.name}</td>

                                    {showbutton ? (
                                      <td>
                                        <div className="product-multi-select-box1">
                                          <MultiSelect
                                            options={country}
                                            value={
                                              trace.countries?.map((c) => ({
                                                value: c.value,
                                                label: c.label,
                                              })) || []
                                            }
                                            onChange={(selected) =>
                                              handleOriginChange(key, selected)
                                            }
                                            classNamePrefix="product-multi-select1"
                                            isSearchable={true}
                                            isMulti
                                          />
                                        </div>
                                      </td>
                                    ) : (
                                      <td>
                                        <div className="trace-countries multiselec-div-btn-heading">
                                        {trace?.countries?.length
                                          ? trace.countries
                                              .map((c) => c.label)
                                              .join(",")
                                          : "-"}
                                          </div>
                                      </td>
                                    )}

                                    <td>
                                      <div className="placeholder-up-input1">
                                      <input
                                        type="text"
                                        value={trace.transactionId || ""}
                                        title={trace.transactionId || ""}
                                        onChange={(e) =>
                                          handleTransactionIdChange(key, e)
                                        }
                                        id={key+"transactionId"}
                                        className="product-modal-currency-price1-table-row-input placeholder-up-input-field multiselec-div-btn-heading truncate-input"
                                        disabled={!showbutton} 
                                      />
                                      </div>
                                    </td>

                                    <td>
                                       <div className="placeholder-up-input1">
                                      <input
                                        type="text"
                                        value={trace.dateTime || ""}
                                        onChange={(e) =>
                                          handleDateTimeChange(key, e)
                                        }
                                        id={key+"dateTime"}
                                        placeholder={showbutton?"dd/mm/yy  hh:mm":""}
                                        // pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\d{4}\s([01][0-9]|2[0-3]):[0-5][0-9]$"
                                        disabled={!showbutton} 
                                        className="product-modal-currency-price1-table-row-input placeholder-up-input-field multiselec-div-btn-heading"
                                      />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductModal;
